export const STATUT_LABELS = {
  nouveau: "Nouveau",
  a_contacter: "À contacter",
  contacte: "Contacté",
  relance_1: "Relance 1",
  relance_2: "Relance 2",
  reponse_recue: "Réponse reçue",
  lead_chaud: "Lead chaud",
  a_rappeler: "À rappeler",
  a_recontacter: "À recontacter",
  pas_interesse: "Pas intéressé",
  desinscrit: "Désinscrit",
  email_invalide: "E-mail invalide",
};

export const STATUT_COLORS = {
  nouveau: "bg-secondary text-foreground",
  a_contacter: "bg-blue-100 text-blue-900",
  contacte: "bg-sky-100 text-sky-900",
  relance_1: "bg-indigo-100 text-indigo-900",
  relance_2: "bg-indigo-200 text-indigo-900",
  reponse_recue: "bg-amber-100 text-amber-900",
  lead_chaud: "bg-orange-500 text-white",
  a_rappeler: "bg-amber-500 text-white",
  a_recontacter: "bg-yellow-100 text-yellow-900",
  pas_interesse: "bg-gray-200 text-gray-600",
  desinscrit: "bg-red-100 text-red-900",
  email_invalide: "bg-red-200 text-red-900",
};

export const CATEGORIE_LABELS = {
  interesse: "Intéressé",
  demande_informations: "Demande d'informations",
  demande_tarifs: "Demande de tarifs",
  demande_devis: "Demande de devis",
  a_rappeler: "À rappeler",
  a_recontacter_plus_tard: "À recontacter plus tard",
  pas_interesse: "Pas intéressé",
  desinscription: "Désinscription",
  reponse_non_comprise: "Réponse non comprise",
};

export const SCORE_NIVEAU_LABELS = {
  tres_chaud: "Lead très chaud",
  chaud: "Lead chaud",
  a_travailler: "À travailler",
  faible: "Faible priorité",
  nurturing: "Nurturing",
  ferme: "Fermé",
};

export const SCORE_NIVEAU_COLORS = {
  tres_chaud: "bg-red-600 text-white",
  chaud: "bg-orange-500 text-white",
  a_travailler: "bg-amber-400 text-amber-950",
  faible: "bg-secondary text-foreground",
  nurturing: "bg-gray-200 text-gray-700",
  ferme: "bg-gray-300 text-gray-600",
};

export const PRIORITE_NIVEAUX = {
  1: { label: "Priorité 1", dot: "🔴", color: "bg-red-600 text-white" },
  2: { label: "Priorité 2", dot: "🟠", color: "bg-orange-500 text-white" },
  3: { label: "Priorité 3", dot: "🟡", color: "bg-amber-300 text-amber-950" },
  4: { label: "Priorité 4", dot: "⚪", color: "bg-secondary text-foreground" },
};

export const PRIORITE_COLORS = {
  haute: "bg-red-600 text-white",
  moyenne: "bg-amber-500 text-white",
  basse: "bg-secondary text-foreground",
};

export const CSV_FIELDS = [
  { id: "raison_sociale", label: "Raison sociale *" },
  { id: "nom_commercial", label: "Nom commercial" },
  { id: "siren", label: "SIREN" },
  { id: "siret", label: "SIRET" },
  { id: "site_internet", label: "Site internet" },
  { id: "secteur", label: "Secteur d'activité" },
  { id: "code_naf", label: "Code NAF" },
  { id: "adresse", label: "Adresse" },
  { id: "code_postal", label: "Code postal" },
  { id: "ville", label: "Ville" },
  { id: "departement", label: "Département" },
  { id: "telephone", label: "Téléphone" },
  { id: "email_generique", label: "E-mail générique" },
  { id: "contact_prenom", label: "Prénom du contact" },
  { id: "contact_nom", label: "Nom du contact" },
  { id: "contact_fonction", label: "Fonction du contact" },
  { id: "contact_email", label: "E-mail professionnel du contact" },
  { id: "taille_estimee", label: "Taille estimée (salariés)" },
  { id: "nb_etablissements", label: "Nombre d'établissements" },
  { id: "besoin_potentiel", label: "Besoin potentiel" },
  { id: "source", label: "Source" },
  { id: "commentaire", label: "Commentaire" },
];
